export default __webpack_public_path__ + "static/media/loginCircle.7e57c5d9.svg";